import PlanSimpleStatusGenerator from "./plan-simple-status-generator";

export default {

    baseUrl: (typeof FlutterSignOutService !== "undefined") ? "/images/" : "/images/",

    getAreas() {
        return ([
            {id: "a1814", name: "regio 18-14", img: "white", treatment: null, position: [22, 0, 50, 50]},
            {id: "a2428", name: "regio 24-28", img: "white", treatment: null, position: [22, 50, 0, 50]},
            {id: "a1323", name: "regio 13-23", img: "white", treatment: null, position: [0, 20, 20, 70]},
            {id: "a4844", name: "regio 48-44", img: "white", treatment: null, position: [50, 0, 50, 19]},
            {id: "a3438", name: "regio 34-38", img: "white", treatment: null, position: [50, 50, 0, 19]},
            {id: "a4333", name: "regio 43-33", img: "white", treatment: null, position: [72, 30, 30, 0]},
        ]);
    },

    getAreaPositions() {
        const ret = {};
        const areas = this.getAreas();
        areas.forEach((area, i) => {
            ret[area.id] = this.getAreaPosition(area);
        });
        return ret;
    },

    getAreaPosition(area) {
        return {
            position: "absolute",
            top: area.position[0]+"%",
            left: area.position[1]+"%",
            right: area.position[2]+"%",
            bottom: area.position[3]+"%",
        };
    },

    getImages(steps) {
        this.images = new Map([]);

        app.$store.state.simplePlan.status.forEach((item) => {
            // if (parseInt(item.state_id) === 1) return;
            if (isNaN(item.tooth_id)) return;
            const img = this.getImage(item.tooth_id, item.state_id, null, true);
            if (img !== null) {
                img.key = "status_" + item.tooth_id + "_" + item.state_id;
                this.images.set(img.key, img);
            }
        });

        steps.forEach((step) => {
            if (!step.primary) return;
            let toothIds = [];
            if (typeof step.tooth_id === "string") toothIds = step.tooth_id.split(",");
            else toothIds = Array.from(step.tooth_id);
            if (toothIds[0] === '') return;

            if ([15].includes(parseInt(step.state_pid)) && parseInt(step.state_id) !== 315) {
                const parts = Helper.breakBridgesToParts(toothIds);
                parts.forEach((partIds) => {
                    this.getConnectors(partIds, null);
                });
            }
            if ([300].includes(parseInt(step.state_pid)) && parseInt(step.state_id) !== 315) {
                this.getGum(toothIds, null);
            }

            // Remove status images

            if ([7].includes(parseInt(step.state_pid))) {
                this.removeStatusImages(toothIds);
                // this.addStatusImages(toothIds, 8); @todo
            }

            /* if ([7].includes(parseInt(step.state_pid))) {
                    this.removeStatusImages(toothIds);
                }*/

            let stateId = step.state_pid;
            if (typeof step.animation_pid !== "undefined") stateId = step.animation_pid;

            toothIds.forEach((toothId) => {
                if (toothId === '' || toothId === 0 || toothId === '0') return;
                const img = this.getImage(toothId, stateId, null);
                if (img !== null) this.images.set(img.key, img);
            });
        });

        return this.sortImages();
    },

    getImages2(groups) {
        this.images = new Map([]);

        const status = PlanSimpleStatusGenerator.getStatus(groups);
        status.forEach((stateId, toothId) => {
            if (parseInt(stateId) === 1) return;

            const img = this.getImage(toothId, stateId, null, true);
            if (img !== null) {
                img.key = "status_" + toothId + "_" + stateId;
                this.images.set(img.key, img);
            }
        });

        groups.forEach((group) => {
            if (typeof group.steps === "undefined") return;

            group.steps.forEach((step) => {
                let toothIds = [];
                if (typeof step.tooth_id === "string") toothIds = step.tooth_id.split(",");
                else toothIds = Array.from(step.tooth_id);

                if ([15].includes(parseInt(step.state_pid)) && parseInt(step.state_id) !== 315) {
                    const parts = Helper.breakBridgesToParts(toothIds);
                    parts.forEach((partIds) => {
                        this.getConnectors(partIds, group);
                    });
                }

                // Remove status images

                if ([7].includes(parseInt(step.state_pid))) {
                    this.removeStatusImages(toothIds);
                    // this.addStatusImages(toothIds, 8); @todo
                }

                /* if ([7].includes(parseInt(step.state_pid))) {
                    this.removeStatusImages(toothIds);
                }*/

                toothIds.forEach((toothId) => {
                    const img = this.getImage(toothId, step.state_pid, group);
                    if (img !== null) this.images.set(img.key, img);
                });
            });
        });

        return this.sortImages();
    },

    removeStatusImages(toothIds) {
        toothIds.forEach((toothId) => {
            this.images.forEach((value, key) =>{
                if (key.includes("status_" + toothId + "_")) {
                    this.images.delete(key);
                }
            });
        });
    },

    addStatusImages(toothIds, stateId) {
        toothIds.forEach((toothId) => {
            const img = this.getImage(toothId, stateId, null, true);
            img.key = "status_" + toothId + "_" + stateId;
            if (img !== null) this.images.set(img.key, img);
        });
    },

    replaceStatusImages(toothIds, stateId) {
        toothIds.forEach((toothId) => {
            this.images.forEach((value, key) =>{
                if (key.includes("status_" + toothId + "_")) {
                    this.images.delete(key);
                    const img = this.getImage(toothId, stateId, null, true);
                    img.key = "status_" + toothId + "_" + stateId;
                    if (img !== null) this.images.set(img.key, img);
                }
            });
        });
    },

    getGum(toothIds, group) {
        toothIds = Helper.sortToothNumbers(toothIds);
        toothIds.forEach((toothId, i) => {
            toothId = parseInt(toothId);
            if (toothId < 18 && toothId >= 11 && i === toothIds.length-1) return;
            else if (toothId >= 21 && toothId < 28 && i === 0) return;
            else if (toothId > 30 && toothId < 40 && i === toothIds.length-1) return;
            else if (toothId >= 40 && i === 0) return;
            const img = {
                toothId: toothId,
                src: this.baseUrl + "smart/300/extra_medium_wide/" + toothId + ".png",
                cssClass: "",
                zIndex: 90 - parseInt(toothId),
                key: "gum." + toothId + "." + (group === null || typeof group.created === "undefined" ? "" : group.created),
                style: this.getToothStyle(toothId, 300, true, group),
            };
            this.images.set(img.key, img);
        });
    },

    getConnectors(toothIds, group) {
        toothIds = Helper.sortToothNumbers(toothIds);
        toothIds.forEach((toothId, i) => {
            toothId = parseInt(toothId);
            if (toothId < 18 && toothId >= 11 && i === toothIds.length-1) return;
            else if (toothId >= 21 && toothId < 28 && i === 0) return;
            else if (toothId > 30 && toothId < 40 && i === toothIds.length-1) return;
            else if (toothId >= 40 && i === 0) return;
            const img = {
                toothId: toothId,
                src: this.baseUrl + "smart/301/" + toothId + ".png",
                cssClass: "",
                zIndex: 90 - parseInt(toothId),
                key: "connector." + toothId + "." + (group === null || typeof group.created === "undefined" ? "" : group.created),
                style: this.getToothStyle(toothId, 301, true, group),
            };
            this.images.set(img.key, img);
        });
    },

    sortImages() {
        // eslint-disable-next-line require-jsdoc
        function compare(a, b) {
            const z1 = a.zIndex;
            const z2 = b.zIndex;
            let comparison = 0;
            if (z1 > z2) {
                comparison = 1;
            } else if (z1 < z2) {
                comparison = -1;
            }
            return comparison;
        }
        return Array.from(this.images.values()).sort(compare);
    },

    getImage(toothId, stateId, group, isStatus = false) {
        stateId = String(stateId);
        toothId = String(toothId);
        if (toothId === "0") return null;

        const allowedStatus = ["1", "3", "4", "6", "7", "8", "19", "16", "30"];
        const allowed = ["6", "7", "9", "10", "11", "13", "15", "26", "1", "3", "4", "300", "303", "308", "312", "318", "320"];
        if (isStatus && !allowedStatus.includes(stateId)) return null;
        if (!isStatus && !allowed.includes(stateId)) return null;

        if (stateId === "1" || stateId === "3" || stateId === "4") stateId = "15";
        if (stateId === "11" || stateId === "312") stateId = "13";
        if (stateId === "6" || stateId === "7") stateId = "305";
        if (stateId === "16") stateId = "19";
        if (stateId === "303") stateId = "300";
        if (stateId === "308") stateId = "300";

        const cssClass = [];
        const withOffset = !isStatus && (stateId === "9" || stateId === "15" || stateId === "26" || stateId === "300" || stateId === "308");

        const style = this.getToothStyle(toothId, stateId, withOffset, group, isStatus);

        return ({
            toothId: toothId,
            stateId: stateId,
            src: this.baseUrl + "smart/" + stateId + "/" + toothId + ".png",
            cssClass: cssClass,
            zIndex: 100 - parseInt(toothId),
            key: stateId + "." + toothId + "." + (group === null || typeof group.created === "undefined" ? "" : group.created),
            style: style,
        });
    },

    getToothStyle(toothId, stateId, withOffset, group, isStatus = false) {
        if (toothId === 0 || toothId === "0" || toothId == "") return {};

        stateId = String(stateId);

        // if (stateId === "15") affectedRegions = 2;
        const affectedRegions = 1;

        let {left, top} = this.getToothPosition(toothId, withOffset, stateId);

        const isFrontTooth = parseInt(toothId) % 10 < 4;
        const isLeftSide = Math.floor(parseInt(toothId) / 10) === 1 || Math.floor(parseInt(toothId) / 10) === 4;
        const isUpperJaw = parseInt(toothId) < 30;

        if (!isStatus && (stateId === "9" || stateId === "15" || stateId === "301" || stateId === "26" || stateId === "300")) {
            // cssClass.push('with-shadow');


            if (affectedRegions > 1) {
                if (!isFrontTooth) left += isLeftSide ? 3 : -3;
                if (isUpperJaw) {
                    top -= isFrontTooth ? 17 : 22;
                } else {
                    top += isFrontTooth ? 14 : 19;
                }
            } else {
                if (!isFrontTooth) left += isLeftSide ? -14 : 14;
                if (isUpperJaw) {
                    top -= isFrontTooth ? 17 : 4;
                } else {
                    top += isFrontTooth ? 14 : 4;
                }
            }
        }

        const baseWidth = 13.1;
        const offsetWidth = 16;
        const maxWidth = (!isStatus && (stateId === "9" || stateId === "15" || stateId === "301" || stateId === "26" || stateId === "300" || stateId === "308")) ? offsetWidth : baseWidth;
        left-= maxWidth / 2;

        return ({
            maxWidth: maxWidth + "%",
            width: maxWidth + "%",
            position: "absolute",
            top: top + "%",
            left: left + "%",
        });
    },

    getToothPosition(toothId, withOffset, stateId = 0) {
        stateId = parseInt(stateId);
        toothId = parseInt(toothId);
        // eslint-disable-next-line no-unused-vars
        const isFrontTooth = toothId % 10 < 4;
        const isLeftSide = Math.floor(toothId / 10) === 1 || Math.floor(toothId / 10) === 4;
        const isUpperJaw = toothId < 30;
        const baseWidth = 13.1;
        const baseHeight = 0;
        const positions = {
            "18": [35.2, 15.3],
            "17": [32.5, 15.8],
            "16": [28, 15.8],
            "15": [25, 17],
            "14": [22, 18.5],
            "13": [15.6, 25],
            "12": [13.8, 30.4],
            "11": [12.1, 38.2],

            "21": [12.1, 48.9],
            "22": [13.8, 57.5],
            "23": [15.6, 63.2],
            "24": [22, 68.5],
            "25": [25, 70],
            "26": [28, 71.6],
            "27": [32.5, 72],
            "28": [35.2, 72],

            "41": [71.1, 40.2],
            "42": [70.2, 34.1],
            "43": [68.8, 29.2],
            "44": [63, 23.5],
            "45": [60.8, 21],
            "46": [58, 18.4],
            "47": [53.8, 16.7],
            "48": [49.6, 16],

            "31": [71.1, 46.5],
            "32": [70.2, 52.6],
            "33": [68.8, 57.6],
            "34": [63, 63.4],
            "35": [60.8, 66],
            "36": [58, 69],
            "37": [53.8, 70.3],
            "38": [49.6, 71],
        };

        const offsetMap = {
            "1": [-2, 2.5],
            "2": [-1, 8],
            "3": [1, 12],
            "4": [-12, 0],
            "5": [-8, 0],
            "6": [-3, 0],
            "7": [2, 0],
            "8": [7, 0],
        };

        let top = !positions[String(toothId)] ? 0 : positions[String(toothId)][0] + baseHeight / 2;
        let left = !positions[String(toothId)] ? 0 : positions[String(toothId)][1] + baseWidth / 2;

        if (withOffset) {
            if (isUpperJaw) top += offsetMap[String(toothId % 10)][0];
            else top -= offsetMap[String(toothId % 10)][0] + 3;

            if (isLeftSide) left -= offsetMap[String(toothId % 10)][1];
            else left += offsetMap[String(toothId % 10)][1];
        }

        if (stateId === 301) {
            top += isUpperJaw ? -3 : 3;
            if (toothId === 11) left += 2;
            if (toothId === 21) left -= 2;
            if (toothId === 13 || toothId === 23) top -= 1;
            if (toothId === 13) left -= 2;
            if (toothId === 23) left += 2;
            if (toothId === 14) left -= 4;
            if (toothId === 24) left += 5;
            if (toothId === 15) left -= 6;
            if (toothId === 25) left += 6;
            if (toothId === 16) left -= 7;
            if (toothId === 26) left += 7;
            if (toothId === 17) left -= 6;
            if (toothId === 27) left += 6;

            if (toothId === 41) {left += 3; top -= 1;}
            if (toothId === 31) {left -= 3; top -= 1;}
            if (toothId === 42) left += 3;
            if (toothId === 32) left -= 3;
            if (toothId === 43 || toothId === 33) top += 1;
            if (toothId === 44 || toothId === 34) top += 1;
            if (toothId === 45) left -= 4;
            if (toothId === 35) left += 4;
            if (toothId === 46) left -= 5;
            if (toothId === 36) left += 5;
            if (toothId === 47) left -= 6;
            if (toothId === 37) left += 6;
        }

        return ({top: top, left: left});
    },

};
